/**
 * ERP Feature Tiers — source of truth is `frigid-backend/src/erp/featureTiers.json`.
 *
 * `featureTiers.json` in this directory is a copy of the backend file. Run
 * `npm run sync:feature-tiers` before building to refresh it.
 */
import FEATURE_TIERS from './featureTiers.json';

export const DEFAULT_TIER = 'basic';

export function getEnabledFeatures(tier) {
  return FEATURE_TIERS[tier] || FEATURE_TIERS[DEFAULT_TIER];
}

export function hasFeature(tier, feature) {
  return getEnabledFeatures(tier).includes(feature);
}
